import store from '@/store';
import { EventEmitter } from 'events';
import { Options, Vue } from 'vue-class-component';
import { Inject } from 'vue-property-decorator';
import EoiWording from '../../assets/config/eoi-wording.json';
import DetailsEdit from '@/components/details-edit/index.vue';
import { CommitteeContactDetail, EoiFormView, MemberDetail, PersonalDetail, EmploymentDetail, CommitteeView, Country } from '@/modules/typescript-cmpApi-client/models';
import { AuthorizedUser } from '@/models/authorized-user';
import { CMPApi } from '@/modules/cmp-api';
import { AppInsights } from '@/appInsights';

@Options({
  props: {
    eoi: {}
  },
  emits: ['update:eoi'],
  components: {
    DetailsEdit
  }
})
export default class DetailsPage extends Vue {
  eoi!: EoiFormView;

  @Inject({ from: 'apiService', default: new CMPApi() })
  private apiService!: CMPApi;

  private ai = new AppInsights;
  private detailsCorrect = null;
  private isPcHolder = false;
  private showModalDetailsEdit = false;
  private memberDetail: MemberDetail = {};
  private employmentDetail: EmploymentDetail = {};
  private personalDetail: PersonalDetail = {};
  private committeeContactDetail: CommitteeContactDetail = {};
  private editType = 0; // 1 - Personal, 2 - Employment, 3 - Contact email;

  private address = '';
  private myCommittees: CommitteeView[] = [];
  private countryList: Country[] = [];
  get pageHeader(): string {
    return "Review your details";
    //return EoiWording[0].details.pageHeader
  }

  get pageBody(): string {
    return "";
    //return EoiWording[0].details.pageBody
  }

  // get eventCtrl(): EventEmitter {
  //   return store.getters.getEventController;
  // }

  @Inject({ from: 'eventController', default: new EventEmitter })
  private eventCtrl!: EventEmitter;

  get userAccount(): AuthorizedUser {
    return store.getters.getUserAccount;
  }

  mounted() {
    this.eventCtrl.emit('isLoadingData', true);
    this.eventCtrl.emit('canSubmit', false);
    this.isPcHolder = this.userAccount.user.isPcHolder || false;
    this.getMyCommittees();
    this.getMyMemberDetails();
    this.getCountryList();
    // check if selection value cached
    setTimeout(() => {
      this.canSubmitCheck();
    }, 1000);

  }

  private getCountryList() {
    // background load countryList for later use
    const countryList = store.getters.getCountryList;
    this.countryList = countryList == null ? null : JSON.parse(countryList);

    if (this.countryList == null) {
      this.apiService.CodeApi?.apiV1CodeGetCountriesGet()
        .then((res: any) => {
          this.countryList = res.data.data;
          store.dispatch('setCountryList', this.countryList);
        })
        .catch((err: any) => {
          console.log(err);
          this.eventCtrl.emit('show-snackbar', 'error', 'Error getting country list: ' + !!err.response.status ? err.response.status : err);
          this.ai.trackException('Error getting country list: ' + err);
        })
    }
  }

  private showEditModal(n: number) {
    this.editType = n;
    this.showModalDetailsEdit = true;
  }

  private getAddressEncoded() {
    let address = this.committeeContactDetail.address;
    const countryName: string = address['countryName'];
    let addressEncoded = '';
    address = JSON.parse(JSON.stringify(address).replace(/:null/gi, ':""'));  // replace all null value
    if (countryName.toLowerCase() == 'australia') {
      switch (address['addressTypeId']) {
        case 1: // Street
          addressEncoded = address['buildingName'] + '\n';
          addressEncoded += address['buildingTypeName'] + ' ' + address['buildingNumber'] + ' ' + address['level'] + '\n';
          addressEncoded += address['streetNumber'] + ' ' + address['streetName'] + ' ' + address['streetTypeName'] + '\n';
          addressEncoded += address['suburbName'] + ', ' + address['stateName'] + ' ' + address['postcode'];
          break;
        case 2: // PO Box
          addressEncoded = address['deliveryTypeName'] + ' ' + address['poBox'] + '\n';
          addressEncoded += address['suburbName'] + ', ' + address['stateName'] + ' ' + address['postcode'];
          break;
        case 3: // DX address
          addressEncoded = 'DX ' + address['dxNumber'] + '\n';
          addressEncoded += address['dxExchangeTypeName'] + '\n';
          break;
      }
    } else {
      addressEncoded = this.committeeContactDetail.address['foreignAddress'] + '\n' + this.committeeContactDetail.address['countryName'];
    }
    return addressEncoded.trim();
  }

  private radioSelect(n: number) {
    if (this.detailsCorrect == 0) {
      this.eoi.confirmPersonalDetails = true;
      this.eoi.confirmEmployeeDetails = true;
      this.eoi.confirmCommitteeContactDetails = true;
      this.canSubmitCheck();
    }
    if (this.detailsCorrect == 1) {
      this.eoi.confirmPersonalDetails = false;
      this.eoi.confirmEmployeeDetails = false;
      this.eoi.confirmCommitteeContactDetails = true;
      this.canSubmitCheck();
    }
    if (this.detailsCorrect == 2) {
      this.eoi.confirmPersonalDetails = true;
      this.eoi.confirmEmployeeDetails = true;
      this.eoi.confirmCommitteeContactDetails = false;
      this.canSubmitCheck();
    }
    this.$emit('update:eoi', this.eoi);
  }

  private canSubmitCheck() {
    const _firmName = this.employmentDetail.firmName !== null && this.employmentDetail.firmName !== '';
    const _address = this.committeeContactDetail.address !== null && this.committeeContactDetail.address !== '';
    const _phoneNumber = this.committeeContactDetail.phone !== null && this.committeeContactDetail.phone !== '';
    const _email = this.committeeContactDetail.email !== null && this.committeeContactDetail.email !== '';
    if (this.isPcHolder) {
      const _confirmCommitteeContactDetails = this.eoi.confirmCommitteeContactDetails !== null ? this.eoi.confirmCommitteeContactDetails : false;
      this.eventCtrl.emit('canSubmit', _confirmCommitteeContactDetails && _address && _phoneNumber && _email);
    } else {
      const _confirmPersonalDetails = this.eoi.confirmPersonalDetails !== null ? this.eoi.confirmPersonalDetails : false;
      this.eventCtrl.emit('canSubmit', _confirmPersonalDetails && this.eoi.confirmEmployeeDetails && _firmName && _address && _phoneNumber && _email);
    }
  }

  private getMyMemberDetails() {
    this.memberDetail = store.getters.getMyMemberDetails;
    this.eventCtrl.emit('is-loading', true);
    if (this.memberDetail == null) {
      this.apiService.memberApi?.apiV1MemberGetMyMemberDetailGet()
        .then((res: any) => {
          store.dispatch('setMyMemberDetails', res.data.data);
          this.personalDetail = res.data.data.personalDetail;
          this.employmentDetail = res.data.data.employmentDetail;
          this.committeeContactDetail = res.data.data.committeeContactDetail;
          this.address = this.committeeContactDetail.address;
          this.eventCtrl.emit('isLoadingData', false);
          this.canSubmitCheck();
        })
        .catch((err: any) => {
          console.log(err);
          this.eventCtrl.emit('show-snackbar', 'error', 'Error getting My Member Details: ' + err.response.status);
          this.ai.trackException('Error getting details info: ' + err);
          this.eventCtrl.emit('isLoadingData', false);
        })

    } else {
      this.eventCtrl.emit('is-loading', false);
      this.personalDetail = this.memberDetail.personalDetail;
      this.employmentDetail = this.memberDetail.employmentDetail;
      this.committeeContactDetail = this.memberDetail.committeeContactDetail;
      this.address = this.committeeContactDetail.address;
      this.eventCtrl.emit('isLoadingData', false);
    }

  }

  private getMyCommittees() {
    this.myCommittees = store.getters.getMyCommittees;
    if (this.myCommittees == null) {
      this.apiService.memberApi?.apiV1MemberGetMyCommitteesGet()
        .then((res: any) => {
          this.myCommittees = res.data.data;
          store.dispatch('setMyCommittees', this.myCommittees);
          this.eventCtrl.emit('isLoadingData', false);
        })
        .catch((err: any) => {
          console.log(err);
          this.eventCtrl.emit('show-snackbar', 'error', 'Error getting My Committee info: ' + err.response.status);
          this.ai.trackException('Error getting EOI committee info: ' + err);
          this.eventCtrl.emit('isLoadingData', false);
        })
    }

  }

  private getPhoneNumber() {
    return (this.committeeContactDetail.phone.phoneAreaCode || '') + ' ' + (this.committeeContactDetail.phone.phoneNumber || '');
  }


}
